module.exports = __webpack_public_path__ + "7cd794fd8e55540ed92e888cad39668f.pdf";